module.exports = __webpack_public_path__ + "static/media/how-it-works-hydraulics-2.081a3a61.gif";